import React, { useState } from 'react';
import { ThemeProvider, useTheme } from './hooks/useTheme';
import { AuthProvider, useAuth } from './hooks/useAuth';
import { Login } from './components/Login';
import FarmDashboard from './components/Dashboard';

const AppContent = () => {
  const { user, loading } = useAuth();
  const { isDark } = useTheme();
  const [showLogin, setShowLogin] = useState(false);

  if (loading) {
    return (
      <div className={`min-h-screen flex items-center justify-center ${isDark ? 'bg-slate-900' : 'bg-gray-50'}`}>
        <div className={`text-xl ${isDark ? 'text-white' : 'text-gray-900'}`}>Loading...</div>
      </div>
    );
  }

  if (showLogin && !user) {
    return <Login isDark={isDark} onBack={() => setShowLogin(false)} />;
  }

  return <FarmDashboard isDemo={!user} onLoginClick={() => setShowLogin(true)} />;
};

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;